import {
  IdCard, Mail, Phone, MessageCircle, MapPin, Briefcase, User,
  Calendar, StickyNote,
} from "lucide-react";

const TIPO_ID_LABEL = {
  cedula: "Cédula", dimex: "DIMEX", cedula_juridica: "Cédula jurídica", pasaporte: "Pasaporte",
};

function Row({ label, value, icon: Icon }) {
  return (
    <div className="py-3 border-b border-[#F0EADC] last:border-none">
      <div className="text-[10px] uppercase tracking-[0.18em] text-[#6B5D57] font-semibold flex items-center gap-1.5">
        {Icon && <Icon className="h-3 w-3" strokeWidth={1.8} />}{label}
      </div>
      <div className="mt-1 text-sm text-[#1A0810]">{value || <span className="text-[#6B5D57]">—</span>}</div>
    </div>
  );
}

function Section({ title, icon: Icon, children }) {
  return (
    <section className="rounded-xl bg-white border border-[#E5DFD3] p-6">
      <div className="flex items-center gap-3 pb-3 border-b border-[#E5DFD3]">
        <div className="h-9 w-9 rounded-md bg-[#F5EEE0] border border-[#E5DFD3] flex items-center justify-center">
          <Icon className="h-4 w-4 text-[#7A1E2E]" strokeWidth={1.8} />
        </div>
        <h3 className="font-display text-lg text-[#1A0810]">{title}</h3>
      </div>
      <div>{children}</div>
    </section>
  );
}

export default function InformacionTab({ cliente }) {
  const dir = cliente.direccion || {};
  const direccionCompleta = [dir.provincia, dir.canton, dir.distrito].filter(Boolean).join(", ");
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-testid="cliente-informacion-tab">
      <Section title="Identificación" icon={IdCard}>
        <Row label="Nombre completo" value={cliente.nombre} icon={User} />
        <Row label="Tipo de identificación" value={TIPO_ID_LABEL[cliente.tipo_identificacion] || cliente.tipo_identificacion} />
        <Row label="Número" value={cliente.identificacion} />
        <Row
          label={cliente.tipo === "juridica" ? "Actividad económica" : "Ocupación"}
          value={cliente.ocupacion}
          icon={Briefcase}
        />
        <Row label="Fecha de ingreso" value={cliente.fecha_ingreso} icon={Calendar} />
      </Section>

      <Section title="Contacto" icon={Phone}>
        <Row label="Teléfono" value={cliente.telefono} icon={Phone} />
        <Row label="WhatsApp" value={cliente.whatsapp} icon={MessageCircle} />
        <Row label="Correo electrónico" value={cliente.email} icon={Mail} />
      </Section>

      <Section title="Dirección" icon={MapPin}>
        <Row label="Provincia / Cantón / Distrito" value={direccionCompleta} />
        <Row label="Dirección exacta" value={dir.detalle} />
      </Section>

      <Section title="Notas internas" icon={StickyNote}>
        <div className="pt-3 text-sm text-[#1A0810] whitespace-pre-wrap">
          {cliente.notas || <span className="text-[#6B5D57]">Sin notas registradas.</span>}
        </div>
      </Section>
    </div>
  );
}
